import React, {Component} from 'react'

import {archiveUrl} from '../../common/services/urls'

export default class Issue extends Component {

    render() {
        return (
            <div className="issue">
                <a href={ `${archiveUrl}/${this.props.number}` } className="issueNumber">ISSUE { this.props.number }</a>
                <span className="issueDate">{this.props.date}</span>
            </div>
        )
    }

}

Issue.propTypes = {
    number: React.PropTypes.number.isRequired,
    date: React.PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/dashboard/archive/Issue.js